import { render } from "./GuaranteePage.vue?vue&type=template&id=1c301c0c&lang=pug"
import script from "./GuaranteePage.vue?vue&type=script&lang=js"
export * from "./GuaranteePage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/chiedocover/chiedohome.com/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__